import { useEffect, useState } from 'react';

import { registerRumSubPage, useRumPage } from '@adv-frontend/rum-kit';
import { useLocation } from '@direct-frontend/modules-router';
import { getRumId } from '../utils';

/**
 * Компонент, обновляющий данные в rum при смене страницы
 */

export const Rum = ({ pageName }: { pageName?: string }) => {
    const location = useLocation();
    const [name, setName] = useState<string | undefined>();
    let pathname = getRumId(location.pathname);

    useRumPage({ pageName: pageName ?? pathname });

    useEffect(() => {
        if (name !== location.pathname) {
            try {
                registerRumSubPage();
            } catch (error) {
                Ya?.Rum?.logError(
                    {
                        message: 'Cannot register RUM subpage',
                        level: Ya.Rum.ERROR_LEVEL.ERROR,
                    },
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- тут инчае не указать тип для error
                    error as Error
                );
            }

            // eslint-disable-next-line react-hooks/set-state-in-effect -- Автоматический игнор в рамках DIRECT-288723
            setName(location.pathname);
        }
    }, [location.pathname, name]);

    return null;
};
